import Modal from "../Modal";
import RenewalOfferForm from "../../forms/opportunity/RenewalOfferForm";
import {useState} from "react";
import UserNewForm from "../../forms/user/UserNewForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function UserNewModal({show, handleClose, callback, title}) {
    const { t } = useTranslation();
    return (
        <Modal title={title} show={show} handleClose={handleClose} width="400px">
            <UserNewForm handleClose={handleClose} callback={callback} />
        </Modal>
    );
};